/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const order = {
  orderDetails: {
    orderId: 'Orden #',
    orderNumber: 'Número de pedido',
    replenishmentId: 'Reposición #',
    purchaseOrderId: 'Orden de compra #',
    purchaseOrderNumber: 'Número de pedido',
    emptyPurchaseOrderId: 'Ninguno',
    none: 'Ninguno {{value}}',
    placed: 'Ponerse',
    placedBy: 'Ponerse By',
    unit: 'Unidad',
    costCenter: 'Centro de costos',
    costCenterAndUnidad: 'Centro de costos / Unidad',
    costCenterAndUnidadValue: '{{costCenterName}} / {{unitName}}',
    methodOfPayment: 'Forma de pago',
    payByAccount: 'Pago a cuenta',
    paidByCreditCard: '(pagado con tarjeta de crédito)',
    status: 'Estado',
    active: 'Activo',
    shippedOn: 'Enviado el',
    shippingMethod: 'Método de envío',
    placedOn: 'Fecha de compra',
    startOn: 'Empezar el',
    nextOrderDate: 'Fecha del próximo pedido',
    frequency: 'Frecuencia',
    cancelled: ' Anulado',
    deliveryStatus_IN_TRANSIT: 'En tránsito',
    deliveryStatus_READY_FOR_PICKUP: 'Listo para recoger',
    deliveryStatus_READY_FOR_SHIPPING: 'Listo para el envío',
    deliveryStatus_WAITING: 'Espera',
    deliveryStatus_DELIVERING: 'Entrega',
    deliveryStatus_PICKPACK: 'Preparación para el envío',
    deliveryStatus_PICKUP_COMPLETE: 'Recogida completa',
    deliveryStatus_DELIVERY_COMPLETED: 'Entrega completa',
    deliveryStatus_PAYMENT_NOT_CAPTURED: 'Problema de pago',
    deliveryStatus_IN_PROCESS: 'En proceso',
    deliveryStatus_READY: 'En proceso',
    deliveryStatus_DELIVERY_REJECTED: 'Entrega rechazada',
    deliveryStatus_SHIPPED: 'Enviado',
    deliveryStatus_TAX_NOT_COMMITTED: 'Cuestión tributaria',
    deliveryStatus_CANCELLED: 'Anulado',
    statusDisplay_cancelled: 'Anulado',
    statusDisplay_cancelling: 'Cancelarar pendiente',
    statusDisplay_completed: 'Completado',
    statusDisplay_created: 'Creado',
    statusDisplay_error: 'Pendiente',
    statusDisplay_checked_valid: 'Pendiente',
    statusDisplay_Error: 'Pendiente',
    statusDisplay_processing: 'Pendiente',
    statusDisplay_open: 'Abrir',
    statusDisplay_pending: {
      approval: 'Pendiente Approval',
      merchant: {
        approval: 'Pendiente Merchant Approval',
      },
    },
    statusDisplay_approved: 'Aprobado',
    statusDisplay_rejected: 'Rechazado',
    statusDisplay_merchant: {
      approved: 'Merchant Aprobado',
      rejected: 'Merchant Rechazado',
    },
    statusDisplay_assigned: {
      admin: 'Asignado al administrador',
    },
    consignmentTracking: {
      action: 'Paquete de seguimiento',
      dialog: {
        header: 'Información de seguimiento',
        shipped: 'Enviado',
        estimate: 'Entrega estimada',
        carrier: 'Servicio de entrega',
        trackingId: 'Número de seguimiento',
        noTracking:
          'El paquete no ha sido enviado desde el almacén. La información de seguimiento estará disponible después de que se envíe el paquete.',
        loadingHeader: 'Seguimiento de envíos',
      },
    },
    payment: {
      title: 'Información de Facturación',
      subtitle: 'Detalles Del Pago',
      user: 'Pedido realizado por:',
      clientNumber: 'Número de Cliente:',
      orderNumber: 'Número de Pedido:'
    },
    downloadOrder: 'Descargar Pedido - PDF',
    cancellationAndReturn: {
      returnAction: 'Solicitar una devolución',
      cancelAction: 'Cancelarar artículos',
      item: 'Artículo',
      itemPrice: 'Precio del artículo',
      quantity: 'Cantidad máxima',
      returnQty: 'Cantidad a devolver',
      cancelQty: 'Cantidad a cancelar',
      setAll: 'Establecer todas las cantidades al máximo',
      totalPrice: 'Total',
      submit: 'Enviar solicitud',
      submitDescription:
        'Enviar solicitud. Los artículos de esta página se incluirán en la solicitud de cancelación.',
      returnSuccess: 'Tu solicitud de devolución ({{rma}}) ha sido enviada',
      cancelSuccess:
        'Su solicitud de cancelación fue enviada (el pedido original {{orderCode}} se actualizará)',
    },
    cancelReplenishment: {
      title: 'Cancelarar reabastecimiento',
      description: 'Cancelar any future replenishment order?',
      accept: 'Sí',
      reject: 'No',
      cancelSuccess:
        'El pedido de reabastecimiento #{{replenishmentOrderCode}} se ha cancelado correctamente',
    },
    caption: 'Contenido del pedido.',
  },
  orderHistory: {
    downloadAll: {
      pdf: 'Descargar todo'
    },
    download: 'Descargar',
    select: 'Seleccionar todo',
    orderHistory: 'Historial de pedidos',
    orderId: 'Orden #',
    emptyPurchaseOrderId: 'Ninguno',
    date: 'Fecha',
    status: 'Estado',
    PONumber: 'Número de correo',
    total: 'Total',
    noOrders: 'No tenemos registros de pedidos para esta cuenta.',
    noReplenishmentOrders:
      'No tenemos registros de pedidos de reabastecimiento para esta cuenta.',
    startShopping: 'Empieza a comprar',
    sortBy: 'Ordenar por',
    sortOrders: 'Criterios de clasificación',
    replenishmentOrderHistory: 'Historial de pedidos de reabastecimiento',
    replenishmentOrderId: 'Reposición #',
    purchaseOrderNumber: 'DESPUÉS #',
    costCenter: 'Centro de costos',
    startOn: 'Empezar el',
    frequency: 'Frecuencia',
    nextOrderDate: 'Fecha del próximo pedido',
    cancel: 'Cancelar',
    cancelled: 'Anulado',
    replenishmentHistory: 'Historial de reabastecimiento',
    notFound: 'No se han encontrado pedidos',
    actions: 'Acciones',
  },
  AccountOrderHistoryTabContainer: {
    tabs: {
      AccountOrderHistoryComponent: 'TODOS LOS PEDIDOS ({{param}})',
      OrderReturnRequestListComponent: 'DEVOLUCIONES ({{param}})',
    },
    tabPanelContainerRegion: 'Agrupar con detalles del historial de pedidos',
  },
  returnRequestList: {
    returnRequestId: 'Devolución #',
    orderId: 'Orden #',
    date: 'Fecha Creado',
    status: 'Estado',
    sortBy: 'Ordenar por',
    sortReturns: 'Ordenar devoluciones',
    statusDisplay_APPROVAL_PENDING: 'Approval Pendiente',
    statusDisplay_CANCELED: 'Anulado',
    statusDisplay_CANCELLING: 'Cancelarling',
    statusDisplay_WAIT: 'Esperar',
    statusDisplay_RECEIVED: 'Recibido',
    statusDisplay_RECEIVING: 'Recibir',
    statusDisplay_APPROVING: 'Aprobatorio',
    statusDisplay_REVERSING_PAYMENT: 'Revertir el pago',
    statusDisplay_PAYMENT_REVERSED: 'Pago revertido',
    statusDisplay_PAYMENT_REVERSAL_FAILED: 'Error en la reversión del pago',
    statusDisplay_REVERSING_TAX: 'Revertir el impuesto',
    statusDisplay_TAX_REVERSED: 'Impuestos revertidos',
    statusDisplay_TAX_REVERSAL_FAILED: 'Falló la reversión de impuestos',
    statusDisplay_COMPLETED: 'Completado',
  },
  returnRequest: {
    returnRequestId: 'Solicitud de devolución #',
    orderCode: 'Para el pedido #',
    status: 'Estado de la devolución',
    cancel: 'Cancelar solicitud de devolución',
    item: 'Descripción',
    itemPrice: 'Precio del artículo',
    returnQty: 'Cantidad devuelta',
    total: 'Total',
    summary: 'Totales de retorno',
    subtotal: 'Subtotal',
    deliveryCode: 'Gastos de envío',
    estimatedRefund: 'Reembolso estimado',
    note: 'Los totales son estimados y es posible que no incluyan los impuestos aplicables u otros cargos.',
    cancelSuccess: 'Tu solicitud de devolución ({{rma}}) ha sido cancelada',
    caption: 'Contenido del pedido.',
  },
  reorder: {
    button: 'Reordenar',
    dialog: {
      reorderProducts: 'Productos Reordenar',
      messages: {
        reviewConfiguration:
          'An error occurred with "{{ productCode}}" configuration.',
        lowStock:
          'Cantidad para {{ productName }}: {{ quantity }} se ha reducido a {{{ quantityAdded }}.',
        noStock: '{{ productName }} está actualmente agotado.',
        pricingError: 'Pricing problem with "{{ productCode }}".',
        unresolvableIssues: 'Unrecognized problem with "{{ productCode }}".',
        success: 'Los productos se han añadido correctamente al carrito',
      },
      areYouSureToReplaceCart: 'El carrito actual será reemplazado con nuevos artículos. ¿Desea continuar?',
      cancel: 'Cancelar',
      continue: 'Continuar',
    },
  },
};
